import "../styles/globals.scss";
import { init } from "@noriginmedia/norigin-spatial-navigation";
import { Provider } from "react-redux";
import Script from "next/script";
import Head from "next/head";
import Store from "../redux/store";
import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import toastConfig from "../config/toastConfig";

init({
  debug: false,
  visualDebug: false,
});
export default function App({ Component, pageProps }) {
  init();
  const [Load, setLoad] = useState(false);
  useEffect(() => {
    function scaleAppSize() {
      const screenW = window.innerWidth;
      const screenH = window.innerHeight;
      const designW = 1920;
      const designH = 1080;
      const widthScaleFactor = screenW / designW;
      const heightScaleFactor = screenH / designH;
      const scaleFactor = Math.min(widthScaleFactor, heightScaleFactor);
      const scaledH = designH * scaleFactor;
      const scaledW = designW * scaleFactor;
      const top = Math.max(screenH - scaledH, 0) / 2;
      const left = Math.max(screenW - scaledW, 0) / 2;

      function px(value) {
        return "" + value + "px";
      }

      const appContent = document.querySelector(".app-content");
      if (appContent) {
        appContent.style.position = "absolute";
        appContent.style.width = px(designW);
        appContent.style.height = px(designH);
        appContent.style.minHeight = px(designH);
        appContent.style.top = px(top);
        appContent.style.left = px(left);
        const transform = "scale(" + scaleFactor + ")";
        const origin = "0% 0% 0";
        appContent.style.transform = transform;
        appContent.style.transformOrigin = origin;
        appContent.style.webkitTransform = transform;
        appContent.style.webkitTransformOrigin = origin;
        setLoad(true);
      }
    }

    window.addEventListener("resize", scaleAppSize);
    scaleAppSize(); // Initial call

    return () => {
      window.removeEventListener("resize", scaleAppSize);
    };
  }, []);
  return (
    <>
      <Head>
        <title>Purple Easy Player</title>
        <meta name="description" content="" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Script
        id="google-ads"
        src="https://imasdk.googleapis.com/js/sdkloader/ima3.js"
        defer
      />
      <script
        id="videojs-ads"
        src="ads.js"
        defer
        onError={(err) => {
          console.error("Error loading ads script:", err);
        }}
      />

      <Script id="WEBAPIS-webapis" src="$WEBAPIS/webapis/webapis.js" defer />
      <Provider store={Store}>
        <div className="app-content">
          <Component {...pageProps} />
        </div>
        <ToastContainer {...toastConfig} />
      </Provider>
    </>
  );
}
